import { getGetHeaders } from "./request";
import Result from "../types/result";
import { parseResponse, runUnauthorizedHandler } from "./response";

interface QueryParams {
  [key: string]: string | number | boolean | string[] | number[] | boolean[] | undefined;
}

const createSearchParams = (queryParams: QueryParams): string => {
  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value === undefined) {
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item) => params.append(key, String(item)));
    } else {
      params.append(key, String(value));
    }
  });

  // Only return "?" if there are any params to append, otherwise return "
  return params.toString() ? `?${params}` : "";
};

async function fetcher<T>(url: string, queryParams: QueryParams = {}): Promise<T> {
  const requestOptions = {
    method: "GET",
    headers: await getGetHeaders()
  };

  const urlParams = createSearchParams(queryParams);
  const response = await fetch(url + urlParams, requestOptions);

  if (!response.ok) {
    if (response.status === 401) runUnauthorizedHandler(response);
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody?.message || `HTTP Error: ${response.status}`);
  }

  return await response.json();
}

export async function fetchResult<T>(url: string, queryParams: QueryParams = {}): Promise<Result<T>> {
  const requestOptions = {
    method: "GET",
    headers: await getGetHeaders()
  };

  const urlParams = createSearchParams(queryParams);
  const response = await fetch(url + urlParams, requestOptions);
  const result = await parseResponse<T>(response);
  return result;
}

export default fetcher;
